﻿export * from './alert.component';
